﻿export * from './alert.component';
